module.exports = __webpack_public_path__ + "media/images/pokerroom/fulltilt/step4-pict01-full-6bcd910bb64e9ed32a23cddaa22431ac.jpg";